<template>
  <form class="PASSWORD-RESET-FORM" @submit.prevent="submit">
    <div class="h4 text-bold m-b-1">
      Password Reset
    </div>
    <div class="m-b-4 INSTRUCTION-TEXT" >
      For a quick sign in next time,
      set a password.

    </div>

    <password-fields ref="passwordfields" :disabled="loading"/>

    <special-message ref="error" type="error" class="m-b-2" selenium="reset-password-error">
      Failed to reset password. Please try again later.
    </special-message>

    <div class="text-left m-b-3">
      Password must:
      <ul class="PASSWORD-LIST">
        <li>At least 8 characters long</li>
        <li>Contain both numbers and letters</li>
      </ul>
    </div>

    <button
        :disabled="loading"
        type="submit"
        class="btn w-100"
        selenium="reset-password-button">
      Set Password
    </button>
  </form>
</template>

<script>
import { updatePassword } from '@homeservices/api-kit/search/user';
import PasswordFields from '@/components/PasswordFields';
import SpecialMessage from '@/components/SpecialMessage';

export default {
  name: 'password-reset',
  components: {
    PasswordFields,
    SpecialMessage,
  },
  props: {
    token: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      loading: false,
    };
  },
  methods: {
    async submit () {
      this.$refs.error.hide();

      const valid = await this.$refs.passwordfields.$validate();
      if (!valid) { return; }

      try {
        this.loading = true;
        await this.$store.dispatch('user/logoutAndClearUserSession');
        await this.$store.dispatch('user/loginUserWithAuthData', {
          access_token: this.token,
          token_type: 'Bearer',
          expires_in: 3600,
        });
        const { data } = await updatePassword({
          password: this.$refs.passwordfields.getPassword(),
          authorization: `Bearer ${this.token}`,
        });
        await this.$store.dispatch('user/loginUserWithAuthData', data);
        this.$router.push({ name: 'homepage' });
      } catch (err) {
        this.$refs.error.trigger(10000);
        this.loading = false;
        throw err;
      } finally {
        this.$refs.passwordfields.reset();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools.scss";

  .PASSWORD-RESET-FORM {
    text-align: center;
    @include margin(6 auto);
    @include mobile-only () {
      padding: 2 * $unit;
    }
    @include responsive(width, 100%, 630px);
    display: block;
  }
   ul.PASSWORD-LIST {
    list-style-position: inside;
    margin: 0;
    padding:2px;
    font-size: 14px;
  }
</style>
